import { View } from "@/components/ui/view";
import React from 'react';
import NodeDescription from "./NodeDescription";


export default function NodeView(props) {
    const {id, data, selected, disabled, nodeHighlighting} = props

    const getColor = (isBorder) => {
        if (nodeHighlighting?.border) {
            if (nodeHighlighting?.error) {
                return isBorder ? 'border-error-600' : 'shadow-error-600'
            }
            if (nodeHighlighting?.info) {
                return isBorder ? 'border-ina-yellow' : 'shadow-ina-yellow'
            }
        }
        return isBorder ? 'border-primary-900' : 'shadow-primary-900'
    }

    return (
        <View
            style={{
                shadowColor: selected ? getColor(false) : "#000000",
                shadowOffset: {
                    width: selected ? 4 : 0,
                    height: 4,
                },
                shadowOpacity: selected ? 0.4 : 0.3,
                shadowRadius: selected ? 20 : 4.65,
                elevation: 8,
            }}
            className={` ${getColor(true)} ${selected || nodeHighlighting?.border ? "border-[4px]" : "border"} max-w-[340px] min-w-[340px] rounded-md pb-0 bg-secondary-50 `}>
            <NodeDescription id={id} data={data} selected={selected} disabled={disabled} nodeHighlighting={nodeHighlighting}/>
            {props.children}
        </View>
    );
}
